import React, { forwardRef } from 'react';
const Power = forwardRef((props, ref) => (React.createElement("svg", { viewBox: "0 0 24 24", height: "1em", role: "img", ref: ref, ...props },
    React.createElement("g", { fill: "currentColor" },
        React.createElement("path", { d: "m16.575.75-.563 1.387A10.476 10.476 0 0 1 22.5 11.85c0 5.813-4.688 10.5-10.5 10.5S1.5 17.662 1.5 11.85c0-4.387 2.663-8.137 6.487-9.712L7.425.75C3.075 2.55 0 6.863 0 11.85c0 6.638 5.362 12 12 12s12-5.362 12-12c0-4.987-3.075-9.3-7.425-11.1z" }),
        React.createElement("path", { d: "M12.75 0h-1.5v12h1.5z" })))));
Power.displayName = 'Power';
// @ts-ignore;
const iconData = {
    glyph: Power,
    group: 'basic',
};
export default iconData;
